import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconNoTransfer = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconNoTransfer",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M320-200v20q0 25-17 43t-43 17-42-17-18-43v-62q-18-20-29-44t-11-54v-347l-76-76q-12-12-12-28t12-29 29-12 28 12l680 680q12 12 12 28t-12 28-28 12-29-12L652-195h114v12q0 26-18 45t-45 18-44-18-19-45v-17zm429-126L566-509q-14-14-6-32t27-19h133v-120H428q-16 0-30-6t-26-17l-96-96q-15-15-10-35t24-27q36-11 84-15t106-4q172 0 246 37t74 123v373q0 20-18 28t-33-7m-409 6q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17M240-560h47l-47-47z"
  })
}));